export default __webpack_public_path__ + "static/media/BannerRegistro.00d19875.jpg";